// @ts-strict-ignore
import { gql } from "@apollo/client";
import {
  SearchCustomersDocument,
  SearchCustomersQuery,
  SearchCustomersQueryVariables,
} from "@dashboard/graphql";
import makeTopLevelSearch from "@dashboard/hooks/makeTopLevelSearch";

export const searchCustomers = gql`
  query SearchCustomers($after: String, $first: Int!, $query: String!) {
    search: customers(after: $after, first: $first, filter: { search: $query }) {
      edges {
        node {
          id
          email
          firstName
          lastName
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
`;

export default makeTopLevelSearch<SearchCustomersQuery, SearchCustomersQueryVariables>(
  SearchCustomersDocument,
);

// Emails used on earlier orders. Staff used to enter draft-order customers as a
// bare email (guest), so a returning customer may have orders but no account;
// the draft customer search offers those emails too.
export const searchOrderCustomerEmails = gql`
  query SearchOrderCustomerEmails($filter: OrderFilterInput!) {
    orders(first: 20, filter: $filter) {
      edges {
        node {
          id
          userEmail
          user {
            id
          }
        }
      }
    }
  }
`;
